import Backgrounds from 'Event/template/NiftyFifty/Dashboard/Resources/Backgrounds'
import ResourceList from 'Event/template/NiftyFifty/Dashboard/Resources/ResourceList'
import React from 'react'

export default function Resources() {
  return (
    <>
      <ResourceList />
      <Backgrounds />
    </>
  )
}
